/*
 * GEHC CONFIDENTIAL
 *
 * Copyright (c) 2025, 2025, GE HealthCare
 * All Rights Reserved
 *
 * This unpublished material is proprietary to GE HealthCare. The methods and
 * techniques described herein are considered trade secrets and/or
 * confidential. Reproduction or distribution, in whole or in part, is
 * forbidden except by express written permission of GE HealthCare.
 * GE is a trademark of General Electric Company used under trademark license.
 */

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent } from 'rxjs';
import { delay, filter, first, timeout } from 'rxjs/operators';

const SHARED_EXAM_TIMEOUT = 2000;

@Injectable({
  providedIn: 'root'
})
export class ExamSharingPageService {
  initialLaunchParameters = null;
  broadcastChannel: BroadcastChannel;
  showCloseTabText = false;
  constructor(private router: Router) {
    this.broadcastChannel = new BroadcastChannel('wfm');
  }

  initiateExternalShare(urlParam: string): void {
    const findTabMessage = { event: 'OPEN_EXAM', body: urlParam };
    this.broadcastChannel.postMessage(findTabMessage);

    const foundTabMessage$ = fromEvent(this.broadcastChannel, 'message').pipe(
      filter((message: MessageEvent) => message.data.event === 'FOUND_ACTIVE_TAB'),
      first(),
      timeout(SHARED_EXAM_TIMEOUT),
      delay(SHARED_EXAM_TIMEOUT)
    );

    foundTabMessage$.subscribe({
      next: () => {
        window.close();
        this.showCloseTabText = true;
      },
      error: () => {
        this.initialLaunchParameters = { event: 'OPEN_EXAM', encryptedExamIdentifier: urlParam };
        this.router.navigate(['/login']);
      }
    });
  }

  getInitialLaunchParameters() {
    return this.initialLaunchParameters;
  }
}
